import { useEffect, useMemo } from "react";

import { useFetchModelListingForMultipleWorkspaces } from "modules/predictive-models/api";
import { useGetModelsByRunForProject } from "modules/projects/api";

import * as flowConfig from "flows/impact-analysis-binary/config";
import { ImpactAnalysisBinaryProject } from "flows/impact-analysis-binary/interfaces";

export const getDataFileId = (project: ImpactAnalysisBinaryProject) =>
  project.data_files[flowConfig.INPUT_DATA];

export const getYConditions = (project: ImpactAnalysisBinaryProject) =>
  project.meta_data[flowConfig.Y_FILTERS_KEY];

export const getYTags = (project: ImpactAnalysisBinaryProject) => [
  project.meta_data[flowConfig.Y_TAG_ONES],
  project.meta_data[flowConfig.Y_TAG_ZEROS],
];

export const getTreatmentConditions = (project: ImpactAnalysisBinaryProject) =>
  project.meta_data[flowConfig.TREATMENT_FILTERS_KEY];

export const getTreatmentControlTags = (
  project: ImpactAnalysisBinaryProject
) => [
  project.meta_data[flowConfig.TREATMENT_TAG],
  project.meta_data[flowConfig.CONTROL_TAG],
];

export const useGetModelsByRun = (project: ImpactAnalysisBinaryProject) =>
  useGetModelsByRunForProject(
    project,
    flowConfig.RUN_ID,
    flowConfig.TIME_STAMP
  );
